import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Alert from '../../../../../../../../../../1stlog-ui/src/components/Alert'

const Wrapper = styled.div``

const OwnArea = (props) => {
  const { isPickup } = props

  return (
    <Wrapper>
      <Alert warning className="mb-1">
        Bitte organisieren Sie {isPickup ? 'oben' : 'unten'} im Bereich{' '}
        {isPickup ? 'Abholung' : 'Zustellung'} einen eigenen Transport.
      </Alert>
      {/* <Badge info>
        {isPickup ? "Abholung" : "Zustellung"} in eigenem Gebiet
      </Badge> */}
      {/* <div className="text-muted">
        Bitte organisieren Sie {isPickup ? "oben" : "unten"} im Bereich{" "}
        {isPickup ? "Abholung" : "Zustellung"} einen eigenen Transport.
      </div> */}
    </Wrapper>
  )
}

export default OwnArea
